export default __webpack_public_path__ + "static/media/24.c679e596.jpeg";